import { createContext, useContext } from 'react';

import { type ApolloQueryResult } from '@apollo/client';

import { type Track } from 'bundles/naptimejs/resources/programCurriculums.v1';
import type {
  VerifiedSkillsEnterpriseBadgeCollectionsQuery as QueryResult,
  VerifiedSkillsEnterpriseBadgeCollectionsQueryVariables as QueryVariables,
  VerifiedSkillsEnterpriseBadgeCollectionFragment,
} from 'bundles/skills-common/shared/verified-skills/data/pathway-badge/__generated__/VerifiedSkillsEnterpriseBadgeCollectionsQuery';
import { type VerifiedSkillsEnterpriseProgramsV1Fragment } from 'bundles/skills-common/shared/verified-skills/data/pathway-badge/__generated__/VerifiedSkillsEnterpriseProgramForCourseQuery';
import { type SkillPathwayCurriculumProductsFragment } from 'bundles/skills-common/shared/verified-skills/data/skill-pathway/__generated__/GetSkillPathwayCurriculumProductsQuery';

export type SkillPathwayEnrollmentData = {
  program?: VerifiedSkillsEnterpriseProgramsV1Fragment | null;
  enrolledBadgeCollection?: VerifiedSkillsEnterpriseBadgeCollectionFragment | null;
  skillPath?: Track;
  skillPathCurriculumProducts: (SkillPathwayCurriculumProductsFragment | null)[];
  refetchEnrolledBadgeCollection?: (variables?: QueryVariables) => Promise<ApolloQueryResult<QueryResult>> | void;
  loading: boolean;
};

const SkillPathwayEnrollmentDataContext = createContext<SkillPathwayEnrollmentData>({
  program: null,
  enrolledBadgeCollection: null,
  skillPath: undefined,
  skillPathCurriculumProducts: [],
  loading: false,
});

export const useSkillPathwayEnrollmentDataContext = (): SkillPathwayEnrollmentData => {
  const context = useContext(SkillPathwayEnrollmentDataContext);

  if (!context) {
    throw new Error('useSkillPathwayEnrollmentDataContext must be used within a SkillPathwayEnrollmentDataProvider');
  }

  return context;
};

export default SkillPathwayEnrollmentDataContext;
